import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DrawingTextDialogData {
  toolLabel: string;
  initial?: string;
}

@Component({
  selector: 'app-drawing-text-dialog',
  templateUrl: './drawing-text-dialog.component.html',
  styleUrls: ['./drawing-text-dialog.component.scss'],
})
export class DrawingTextDialogComponent {
  public text: string;

  constructor(
    public dialogRef: MatDialogRef<DrawingTextDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: DrawingTextDialogData
  ) {
    this.text = data.initial ?? '';
  }

  public accept(): void {
    this.dialogRef.close(this.text);
  }

  public cancel(): void {
    this.dialogRef.close(undefined);
  }
}
